import React from 'react'

import styles from './play-button.module.css'
import { classes } from '../util/components'

const PlayButton = props => (
  <button {...props} className={classes(styles.playButton, props.className)}>
    <svg width="87px" height="98px" viewBox="0 0 87 98">
      <path
        d="M536 284.182c0-5.534 6.027-9.012 10.786-6.166l36.322 20.87 36.323 20.71c4.759 2.689 4.759 9.645 0 12.491l-36.323 20.87-36.322 21.027c-4.759 2.846-10.786-.632-10.786-6.166v-83.636z"
        transform="translate(-676 -692) translate(0 286) translate(0 42) translate(100 87) translate(40)"
        fill="#FFF"
        fillRule="nonzero"
        stroke="none"
        strokeWidth={1}
        opacity={0.392764137}
      />
    </svg>
  </button>
)

export default PlayButton
